import { render } from "./Modal.vue?vue&type=template&id=177f8d4b&scoped=true"
import script from "./Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal.vue?vue&type=script&setup=true&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=177f8d4b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177f8d4b"],['__file',"src/components/modal/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "177f8d4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('177f8d4b', __exports__)) {
    api.reload('177f8d4b', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=177f8d4b&scoped=true", () => {
    api.rerender('177f8d4b', render)
  })

}


export default __exports__